import ConnectBankAccount from '@/components/bank-account/connect/index';

export default ConnectBankAccount;
